module.exports = __webpack_public_path__ + "assets/img/spider-attack.78dc70c4.png";